import { CustomBookingsMethodTestRun } from '~api/som';

import { useMemo, useState } from 'react';

import { Banner, DotBadge, Spinner } from '@ingrid/luterkort-react';

import { SimpleSelect } from '~src/components/SimpleSelect/SimpleSelect';
import { useTranslation } from '~src/i18n/use-translation';
import { toPrettyJson } from '~src/utils/json';

import { useConfiguratorContext } from './configurator-context';
import { DiffEditor } from './diff-editor';
import { RunTestButton } from './run-test-button';
import { Footer, Wrapper } from './test-runner-layout';

export function TestRunnerFinalOutput() {
  const { runs, isRunning } = useConfiguratorContext();
  const { t } = useTranslation();

  const [selected, setSelected] = useState<string>('0');

  const result = useMemo<CustomBookingsMethodTestRun | undefined>(() => runs[Number(selected)], [runs, selected]);
  const error = useMemo(() => result?.errors, [result]);

  return (
    <Wrapper>
      {error && <Banner style={{ marginBottom: '16px' }} variant="critical" title={error} />}

      <div style={{ flex: 1, position: 'relative', overflowY: 'scroll', paddingBottom: '16px' }}>
        {result && (
          <DiffEditor modified={toPrettyJson(result.output_shipment)} original={toPrettyJson(result.input_shipment)} />
        )}

        {isRunning && <Spinner style={{ height: '100%', display: 'flex', justifyContent: 'center' }} />}
      </div>

      <Footer>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <SimpleSelect
            renderOptionLabel={([value, label]) => (
              <DotBadge variant={runs[Number(value)].errors ? 'critical' : 'success'}>{label}</DotBadge>
            )}
            options={runs.map((_, index) => [
              index.toString(),
              t('bookingRules.edit.test-shipment-option', { id: index + 1 }),
            ])}
            onValueChange={([value]) => setSelected(value)}
            value={[selected]}
          />
        </div>

        <RunTestButton i18nKey="bookingRules.edit.re-run-test" />
      </Footer>
    </Wrapper>
  );
}
